angular.module('extra2App')
   .controller('PepsiPromotionController', ['$scope', '$sce', 'page', 'restservice', '$translatePartialLoader', '$translate', '$window',
      function ($scope, $sce, page, restservice, $translatePartialLoader, $translate, $window) {

         $translatePartialLoader.addPart('pepsipromotion');
         $translate.refresh();

         $scope.joinButtonEnabled = false;

         page.setTitle($translate.instant('pepsi_promotion.title'));

         $scope.joinPepsiPromo = function() {
            restservice.enablePepsiMarketingDetails().then(function (response) {
               if(response.status === 200) {
                  $window.location.href = '#/dashboard';
               } else {
                  $location.path('/global-failure-page');
               }
            });
         }

         $scope.skipPepsiPromo = function() {
            $window.location.href = '#/dashboard';
         }
   }]);
